<script>
import { computedPbxBasePlans,computedPbxPlans } from '@/common/service/computers/plans/pbx';
import { PBX_GS } from '../helper/constants';
import { mapGetters } from 'vuex';
import Config from './config.vue';
import Edit from './edit.vue';
import Upsell from './upsell.vue';

export default {
  props: {
    configPlanTileStatus: {
      type: Object,
      default: () => ({}),
    },
    isAddon: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters(['boughtPlans','getSelectedPlans']),
    hasBoughtPbxBasePlan(){
      return !!computedPbxBasePlans(this.boughtPlans).length;
    },
    isGlobalSelect(){
      return computedPbxPlans(this.getSelectedPlans).some(item => PBX_GS.includes(item.category)) && this.$config('enableZoomPhoneGlobalSelect')
    },
  },
  render() {
    const context = {
      ...{
        props: { ...this.$attrs, configPlanTileStatus: this.configPlanTileStatus },
        on: { ...this.$listeners },
      },
    };
    if (this.isGlobalSelect && this.$context.is.edit) return <Edit {...context} />;
    if (this.$context.is.edit) return <Edit {...context} />;
    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <Config {...context} />;
    if (this.$context.is.add2cart){
      if(this.hasBoughtPbxBasePlan) return <Edit {...context} />;
      return <Config {...context} />;
    }
    if (this.$context.is.upsell) return <Upsell {...context} />;
    return null;
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-pbx {
  &-head {
    align-items: flex-start !important;
    &__logo--left {
      display: flex;
      align-items: flex-start;
      flex-shrink: 0;

      .opc-pbx__logo, .opc-pbx-regional__logo-icon, .opc-pbx__logo-icon {
        width: 44px;
        height: auto;

        @include media(mobile, tablet) {
          width: 32px;
        }
      }
    }
  }

  &__title-wrapper {
    color: #00053D;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;

    .zm-icon-success {
      font-size: 16px !important;
    }
  }
}

.opc-pbx {
  &__plan {
    &--name {
      font-family: 'Almaden Sans' !important;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 150%; /* 30px */
    }
  }

}
</style>
